import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'allas-margin-wrapper',
  imports: [CommonModule],
  template: `
    <main
      class="w-full max-w-[1600px] mx-auto px-4 {{ styleClass }}"
      lang="es-HN"
    >
      <ng-content></ng-content>
    </main>
  `,
})
export class MarginWrapper {
  @Input() styleClass: string = '';
}
